import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Paper, Switch, Button, Divider, } from "@mui/material";
import axios from "axios";
import { API_URL } from "../services/authService";
import EditUser from "./EditUser";
import AnyModal from "../subComponent/AnyModel";
import { useState } from "react";

const ManageUsers = ({ data, onClose }) => {
    const headCellStyle = {
        color: "white",
        fontWeight: "bold",
        fontSize: "1rem",
    };

    const [openModal, setOpenModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    
    const handleOpenModal = (user) => {
        setSelectedUser(user);
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedUser(null);
    };

    const toggleUserStatus = async (userId, currentStatus) => {
        try {
            // Get token from localStorage
            const userData = localStorage.getItem('invCreator');
            if (!userData) {
                throw new Error('Authentication token not found');
            }
            const { token } = JSON.parse(userData);

            // Find the store in the current list to get all required fields
            const userToUpdate = data.find(user => user.user_id === userId);
            if (!userToUpdate) {
                throw new Error('Store not found');
            }

            // Make API call to update store status with all required fields
            const response = await axios.put(
                `${API_URL}/update_user_by_id/${userId}`,
                {
                    status: !currentStatus
                },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            // console.log(response);
            if (response.statusText === "OK") {
                // Refresh users list
                // console.log("ok");
                onClose();
            }
        } catch (error) {
            console.error("Error updating store status:", error);
        }
    };

    return (
        <Box sx={{ p: 3 }}>

            <TableContainer component={Paper} sx={{ mx: "auto" }}>
                <Table>
                    <TableHead sx={{ backgroundColor: "#3e8596" }}>
                        <TableRow>
                            <TableCell sx={headCellStyle}>User Name</TableCell>
                            <TableCell sx={headCellStyle}>Email</TableCell>
                            <TableCell sx={headCellStyle}>Role</TableCell>
                            <TableCell sx={headCellStyle}>Action</TableCell>
                            <TableCell sx={headCellStyle}>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data && data.length > 0 ? (
                            data.map((user, index) => (
                                <TableRow
                                    key={user.user_id}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? "white" : "lightgrey",
                                        "&:hover td": {
                                            color: "green",
                                        },
                                    }}
                                >
                                    <TableCell>{user.username}</TableCell>
                                    <TableCell>{user.email}</TableCell>
                                    <TableCell>{user.role}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => handleOpenModal(user)}
                                        >
                                            Edit
                                        </Button>
                                    </TableCell>
                                    <TableCell>
                                        <Switch
                                            checked={user.status}
                                            onChange={() =>
                                                toggleUserStatus(user.user_id, user.status)
                                            }
                                            color="primary"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No users found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer >

            {/* New Add edit Modal */}
            <AnyModal
                open={openModal}
                onClose={handleCloseModal}
                headTitle="Edit User Details"
                ComponentComp={selectedUser ? EditUser : Box}
                data={selectedUser}
                fetch={onClose}
                />
        </Box >
    );
};

export default ManageUsers;